/**
 * Custom (whitelabel) domain when the browser origin differs from REACT_APP_APP_URL.
 * Same check as useWhiteListing / isWhiteListed.
 */
export function isWhiteListedAppOrigin(): boolean {
	return process.env.REACT_APP_APP_URL != window.location.origin;
}

/** Base origin for auth and cross-page redirects: current origin on custom domain, else REACT_APP_PUBLIC_URL. */
export function getAppPublicOrigin(): string {
	return isWhiteListedAppOrigin() ? window.location.origin : process.env.REACT_APP_PUBLIC_URL!;
}

export function getAppAbsoluteUrl(path: string): string {
	const normalizedPath = path.startsWith('/') ? path : `/${path}`;
	return `${getAppPublicOrigin()}${normalizedPath}`;
}

/** Login entry: custom domains use /social-login on the current origin; default domain uses /login. */
export function getLoginUrl(): string {
	if (isWhiteListedAppOrigin()) {
		return `${window.location.origin}/`;
	}
	return `${process.env.REACT_APP_PUBLIC_URL}/login`;
}

export function getSocialLoginUrl(): string {
	if (isWhiteListedAppOrigin()) {
		return `${window.location.origin}/`;
	}
	return `${process.env.REACT_APP_PUBLIC_URL}/social-login`;
}

export function getPostLogoutUrl(search = ''): string {
	return getAppAbsoluteUrl(`/logout${search}`);
}
